import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../../app.constants';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { ListWidgetModel } from '../../models/widget-related/ListWidgetModel';

@Injectable()
export class ListWidgetService {

    private actionUrl: string;
    private headers: Headers;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/ListWidget/`;
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (widget: string, widgetId: string): Observable<ListWidgetModel> => {
        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        params.set('widgetId', widgetId);

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl + widget, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/list-widget-container/list-widget/list-widget.service.ts